//import libraries
import { formatDate } from '@angular/common';
import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { fromEvent } from 'rxjs';
import { debounceTime, map } from 'rxjs/operators';
import { ConfirmationDialogService } from 'src/app/components/general/modals/confirmation/confirmation.service';
import { AppFrontRoutes } from 'src/app/constants/app-front-routes';
import { AppSettings } from 'src/app/constants/app-settings';
import { GeneralService } from 'src/app/services/general.service';
import { PrivacyService } from 'src/app/services/privacy.service';
import { CommonUtility } from 'src/app/utility/commonUtility';
import { TreatmentRegisterCreateComponent } from '../treatment-register/treatment-register-create/treatment-register-create.component';
declare var $: any;

@Component({
  selector: 'app-appointment-data-processor',
  templateUrl: './appointment-data-processor.component.html',
  styleUrls: ['./appointment-data-processor.component.css']
})
export class AppointmentDataProcessorComponent implements OnInit, AfterViewInit {
  records:any;
  datatableCols1:any;
  datatableColsDefs:any;
  datatableOptions:any;
  deleteOption: boolean;
  lang: any;
  temp: any;
  rolepermission: any;
  readonly AppSettings = AppSettings;
  readonly AppFrontRoutes = AppFrontRoutes;

  constructor(
    private privacy:PrivacyService,
    private modalService: BsModalService,
    private confirmationDialogService: ConfirmationDialogService,
    private generalService: GeneralService,
    private utility: CommonUtility,
    private router: Router,    
  ) { }

  ngAfterViewInit(){
    const that = this
    setTimeout(function(){
      fromEvent(this.treatmentSearch, 'keydown')
      .pipe(
        debounceTime(550),
        map(x => x['target']['value'])
      )
      .subscribe(value => {
        // this.updateFilter(value);
        console.log(value) 
        console.log(that.records) 
        that.records = that.utility.updateFilter(value,that.datatableCols1,that.records,that.temp)
        console.log(that.records)
      });   
     

    },3000)      
  }

  ngOnInit() {
    this.getAllTreatmentList()  

    this.datatableColsDefs = [
      {
        targets: 0,
        visible: false,
        orderable: false,
      },
      {
        targets: 1,
        orderable: false,
        className: 'select-checkbox'
      },
    ];


    this.datatableOptions = {
      paging: false,
      bAutoWidth: false,
      bSortClasses: false,
      columnDefs: this.datatableColsDefs,
      select: {
        style: 'multi',
        selector: 'td:first-child'
      },
      headerCallback: function (thead, data, start, end, display) {

        $('th:first-child input', thead).unbind('click');
        $('th:first-child input', thead).bind('click', () => {

          var table1 = new $.fn.dataTable.Api('#table1');

          var count = table1.rows({ selected: true }).count();
          let selected = true;

          if (count > 0) {
            table1.rows().deselect();
            selected = false;
          }
          else
            table1.rows().select();

          $('th:first-child input', thead).prop("checked", selected);

        });
      },
      initComplete: () => {

        var self = this;
        var table1 = new $.fn.dataTable.Api('#table1');

        table1
          .on('select deselect', function (e, dt, type, indexes) {

            var table1 = new $.fn.dataTable.Api('#table1');
            var selected = table1.rows({ selected: true }).indexes().toArray();

            if (selected.length === 0)
              self.deleteOption = false;
            else
              self.deleteOption = true;
          });

        var buttons1 = new $.fn.dataTable.Buttons(table1, {
          dom: {
            button: {
              className: ''
            }
          },
          buttons: [
            {
              extend: 'csv',
              text: this.lang.exportCsv,
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table1');
                  var selected = dt.rows({ selected: true }).indexes().toArray();
                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCluod_DEMO_qualified_teacher_"  + formatDate(new Date(), 'yyMMdd', 'en') + '_' + formatDate(new Date(), 'hhmmss', 'en')
            },
            {
              extend: 'pdfHtml5',
              text: this.lang.exportPdf,
              className: 'btn btn-info',
              orientation: 'landscape',
              pageSize: 'A3',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table1');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;


                  return false;
                }
              },
              title: "KaizenCluod_DEMO_qualified_teacher_"  + formatDate(new Date(), 'yyMMdd', 'en') + '_' + formatDate(new Date(), 'hhmmss', 'en')
            },
            {
              extend: 'excel',
              text: this.lang.exportExcel,
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table1');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCluod_DEMO_qualified_teacher_"  + formatDate(new Date(), 'yyMMdd', 'en') + '_' + formatDate(new Date(), 'hhmmss', 'en')
            },
            {
              extend: 'print',
              text: this.lang.print,
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table1');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCluod_DEMO_qualified_teacher_"  + formatDate(new Date(), 'yyMMdd', 'en') + '_' + formatDate(new Date(), 'hhmmss', 'en')
            },
          ], select: true
        }).container().appendTo($('#datatableExportBtn1'));

      }
    }    
  }


  export1_select_deselect_all(event): void {

    let selected = false;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols1.length; i++) {
      this.datatableCols1[i].isSelected = selected;
    }
    this.datatable_export1_choose_column();

  }  

  datatable_export1_choose_column(): void {

    var table1_name = '#table1';
    var table1 = new $.fn.dataTable.Api(table1_name);

    for (var i = 0; i < this.datatableCols1.length; i++) {
      if (this.datatableCols1[i].isSelected)
        table1.column(parseInt(this.datatableCols1[i].id)).select();
      else
        table1.column(parseInt(this.datatableCols1[i].id)).deselect();
    }

  }  

  getAllTreatmentList(){
    this.privacy.fetchTreatmentRegister().subscribe(
      (response) => {
        this.lang = this.privacy.treatmentRegisterList(response);
        this.records = this.temp =  response.data.records;

        this.datatableCols1 = [
          { id: 2, value: this.lang.no, isSelected: false },
          { id: 3, value: this.lang.code, isSelected: false },
          { id: 4, value: this.lang.desc_of_treatment, isSelected: false },
          { id: 5, value: this.lang.purpose, isSelected: false },
          { id: 6, value: this.lang.type, isSelected: false },
          { id: 7, value: this.lang.tools_data_processing, isSelected: false },
          { id: 8, value: this.lang.physical_location_data_storage, isSelected: false },
          { id: 9, value: this.lang.type_access_computer_data, isSelected: false },
          { id: 10, value: this.lang.physical_location_data_archieve, isSelected: false },
          { id: 11, value: this.lang.type_access_papper_data, isSelected: false },
          { id: 12, value: this.lang.action, isSelected: false },
        ];    
    

      },
      (error) => {

      }
    )
  }

  addEditTreatmentRegister(type,id){
    this.modalService.show(TreatmentRegisterCreateComponent, { class: 'modal-lgs', initialState: { 'ID': id, 'lang': this.lang,type:type } });
  }

  redirect() {
    this.router.navigateByUrl('/test', { skipLocationChange: true })
      .then(() => {
        this.router.navigate([AppFrontRoutes.PRIVACY_TREATMENT_REGISTER]);
      });
  }

  delete(ID) {
    
    this.confirmationDialogService.confirm('Delete Confirmation', 'Are you sure to delete?')
        .subscribe(
          (confirmed) => {
            
            if (!confirmed)
              return;

            this.privacy.deleteTreatmentCreation({"treatment_id":ID})
              .subscribe(
                (res) => {
                  
                  if (res.status)
                  this.generalService.notify_msg('success', res.msg);
                  else
                  this.generalService.notify_msg('error', res.msg);

                  this.redirect()
              },  
              (error) => {
                this.generalService.notify_msg('error', "Unable to edit error");
              });

    });
  }



}
